/**
 * Location Filter Utility
 * Handles extraction of location IDs from parent window URL when app is in an iframe
 * 
 * Expected URL format in parent window: ?organization_id=6625&locations=4752,4890,4982,5210&token=
 */

/**
 * Gets location IDs from parent window URL
 * Since we're in an iframe, we need to access the parent window's URL
 * @returns {Array<string>} Array of location IDs, or empty array if not found or not accessible
 */
export function getLocationIdsFromParentURL() {
  try {
    // Try to access parent window URL (may fail due to CORS)
    if (window.parent && window.parent !== window) {
      try {
        const parentUrl = window.parent.location.href
        const parentUrlObj = new URL(parentUrl)
        const parentParams = new URLSearchParams(parentUrlObj.search)
        const locationsParam = parentParams.get('locations')
        
        if (locationsParam) {
          // Parse comma-separated location IDs
          const locationIds = locationsParam
            .split(',')
            .map(id => id.trim())
            .filter(id => id.length > 0)
          
          if (locationIds.length > 0) {
          return locationIds
        }
        }
      } catch (e) {
        // CORS error - can't access parent location (expected in cross-origin iframes)
        // Silently fall back to current URL - this is normal behavior
      }
    }
    
    // Fallback: Try to get from current window URL (in case locations are passed through)
    const urlParams = new URLSearchParams(window.location.search)
    const locationsParam = urlParams.get('locations')
    
    if (locationsParam) {
      const locationIds = locationsParam
        .split(',')
        .map(id => id.trim())
        .filter(id => id.length > 0)
      
      if (locationIds.length > 0) {
        return locationIds
      }
    }
    
    // No locations found
    return []
  } catch (error) {
    // Silently handle errors - CORS is expected in cross-origin iframes
    return []
  }
}

